module.exports = __webpack_public_path__ + "img/close-fill.faed3f6a.svg";